import { DatePicker, Input, Form } from "antd";
import TextArea from "antd/lib/input/TextArea";
import * as React from "react";
import moment from "moment";
import { TableAPI } from "../../API/TableAPI";
import { FormInstance } from "antd/lib/form";
import { makeEntryModal } from "./CreateEntryModals";
import Entry from "../../Model/Entry";

function renderForm(form: FormInstance) {
  return (
    <Form className="modal-form" hideRequiredMark={true} form={form}>
      <Form.Item
        name="name"
        label="Name"
        rules={[{ required: true, message: "Name is required" }]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="timespan"
        label="Timespan"
        rules={[{ required: true, message: "This field is not optional" }]}
      >
        <DatePicker.RangePicker format="YYYY-MM-DD" />
      </Form.Item>

      <Form.Item
        name="region"
        label="Region"
        rules={[
          { required: true, message: "This field is not optional" },
          { pattern: /[A-Z].*/g, message: "Please use capitalised words" },
        ]}
      >
        <Input />
      </Form.Item>

      <Form.Item
        name="objective"
        label="Objective"
        rules={[{ required: true, message: "This field is not optional" }]}
      >
        <TextArea placeholder="Small description of the campaign" />
      </Form.Item>

      <Form.Item
        name="website"
        label="Website"
        rules={[{ type: "url", message: "Must be a valid URL" }]}
      >
        <Input
          type="url"
          placeholder="If exists, include 'http://', 'https://''"
        />
      </Form.Item>

      <Form.Item
        name="references"
        label="References"
        rules={[{ required: true, message: "Please insert some references" }]}
      >
        <TextArea />
      </Form.Item>
    </Form>
  );
}

function formToEntry(form: FormInstance) {
  // Format dates
  const timespanMoments = form.getFieldValue("timespan");
  const timespan = {
    from:
      timespanMoments[0] === undefined
        ? null
        : timespanMoments[0].format("YYYY-MM-DD"),
    to:
      timespanMoments[1] === undefined
        ? null
        : timespanMoments[1].format("YYYY-MM-DD"),
  };

  const values = {
    ...form.getFieldsValue([
      "name",
      "region",
      "objective",
      "website",
      "references",
    ]),
    timespanFrom: timespan.from,
    timespanTo: timespan.from,
  } as Entry;

  if (!values["website"] || values["website"].length === 0) {
    values["website"] = undefined;
  }

  // Return entry
  return values;
}

function entryToForm(form: FormInstance, entry: Entry) {
  form.setFieldsValue({
    ...entry,
    timespan: [
      moment(entry.timespanFrom, "YYYY-MM-DD"),
      moment(entry.timespanTo, "YYYY-MM-DD"),
    ],
  });
}

export const CreateCampaignModal = makeEntryModal(
  "Create Campaign",
  new TableAPI("campaigns"),
  renderForm,
  formToEntry,
  entryToForm
);
